var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup as MuiRadioGroup, } from "@mui/material";
import React from "react";
export function RadioGroup(props) {
    const { label, value, onChange, options, renderLabel } = props, radioGroupProps = __rest(props, ["label", "value", "onChange", "options", "renderLabel"]);
    return (React.createElement(FormControl, null,
        label && React.createElement(FormLabel, null, label),
        React.createElement(MuiRadioGroup, Object.assign({ value: value, onChange: (_, value) => onChange(value) }, radioGroupProps), options.map(option => (React.createElement(FormControlLabel, { key: option, control: React.createElement(Radio, { value: option }), label: renderLabel ? renderLabel(option) : option }))))));
}
//# sourceMappingURL=RadioGroup.js.map